/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { BoxPb } from "./box";
import { CylinderPb } from "./cylinder";
import { HalfPlanePb } from "./half_plane";
import { PolygonPb } from "./polygon";
import { SpherePb } from "./sphere";

export const protobufPackage = "shape_map";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ShapeMapPb {
  utime: number;
  halfPlanes: HalfPlanePb[];
  spheres: SpherePb[];
  cylinders: CylinderPb[];
  boxes: BoxPb[];
  polygons: PolygonPb[];
}

function createBaseShapeMapPb(): ShapeMapPb {
  return { utime: 0, halfPlanes: [], spheres: [], cylinders: [], boxes: [], polygons: [] };
}

export const ShapeMapPb = {
  encode(message: ShapeMapPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    for (const v of message.halfPlanes) {
      HalfPlanePb.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.spheres) {
      SpherePb.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.cylinders) {
      CylinderPb.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.boxes) {
      BoxPb.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    for (const v of message.polygons) {
      PolygonPb.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ShapeMapPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShapeMapPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.halfPlanes.push(HalfPlanePb.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.spheres.push(SpherePb.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.cylinders.push(CylinderPb.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.boxes.push(BoxPb.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.polygons.push(PolygonPb.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShapeMapPb {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      halfPlanes: globalThis.Array.isArray(object?.halfPlanes)
        ? object.halfPlanes.map((e: any) => HalfPlanePb.fromJSON(e))
        : [],
      spheres: globalThis.Array.isArray(object?.spheres) ? object.spheres.map((e: any) => SpherePb.fromJSON(e)) : [],
      cylinders: globalThis.Array.isArray(object?.cylinders)
        ? object.cylinders.map((e: any) => CylinderPb.fromJSON(e))
        : [],
      boxes: globalThis.Array.isArray(object?.boxes) ? object.boxes.map((e: any) => BoxPb.fromJSON(e)) : [],
      polygons: globalThis.Array.isArray(object?.polygons)
        ? object.polygons.map((e: any) => PolygonPb.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ShapeMapPb): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.halfPlanes?.length) {
      obj.halfPlanes = message.halfPlanes.map((e) => HalfPlanePb.toJSON(e));
    }
    if (message.spheres?.length) {
      obj.spheres = message.spheres.map((e) => SpherePb.toJSON(e));
    }
    if (message.cylinders?.length) {
      obj.cylinders = message.cylinders.map((e) => CylinderPb.toJSON(e));
    }
    if (message.boxes?.length) {
      obj.boxes = message.boxes.map((e) => BoxPb.toJSON(e));
    }
    if (message.polygons?.length) {
      obj.polygons = message.polygons.map((e) => PolygonPb.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ShapeMapPb>, I>>(base?: I): ShapeMapPb {
    return ShapeMapPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShapeMapPb>, I>>(object: I): ShapeMapPb {
    const message = createBaseShapeMapPb();
    message.utime = object.utime ?? 0;
    message.halfPlanes = object.halfPlanes?.map((e) => HalfPlanePb.fromPartial(e)) || [];
    message.spheres = object.spheres?.map((e) => SpherePb.fromPartial(e)) || [];
    message.cylinders = object.cylinders?.map((e) => CylinderPb.fromPartial(e)) || [];
    message.boxes = object.boxes?.map((e) => BoxPb.fromPartial(e)) || [];
    message.polygons = object.polygons?.map((e) => PolygonPb.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
